import { render } from "./Steps.vue?vue&type=template&id=23ad7d2d"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"

import "./Steps.vue?vue&type=style&index=0&id=23ad7d2d&lang=scss"
script.render = render

export default script